import React, { useState } from 'react';
import styled from 'styled-components';

import ManualAccountLogo from 'components/accounts/ManualAccountLogo';

import { variables } from 'common/lib/theme/dynamic';

const DEFAULT_SIZE_PX = 48;

type Props = {
  logo: string | null;
  className?: string; // used for styled components
  size?: number;
  alt?: string;
};

type StyledImgProps = {
  $size: number;
};

const StyledImg = styled.img<StyledImgProps>`
  border-radius: 100%;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  flex-shrink: 0;
  object-fit: cover;
  box-shadow: inset 0 0 0 1px ${variables.color.avatar.border};
`;

const getLogoUrl = (logo: string) => {
  if (logo.startsWith('http') || logo.startsWith('data:image')) {
    return logo;
  }

  // some logos are base64 encoded strings without the prefix
  // try to render them as a png
  return `data:image/png;base64,${logo}`;
};

const InstitutionLogo = ({ logo, size = DEFAULT_SIZE_PX, className, alt }: Props) => {
  const [hasImageError, setHasImageError] = useState(false);

  if (logo && !hasImageError) {
    return (
      <StyledImg
        className={className}
        $size={size}
        src={getLogoUrl(logo)}
        onError={() => setHasImageError(true)}
        alt={alt}
      />
    );
  }

  return <ManualAccountLogo icon="dollar-sign" size={size} className={className} />;
};

export default InstitutionLogo;
